import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex w-full border-l-[10px] border-primary-400 mt-8 mb-8 text-left pt-2 pb-2 pl-4 gap-4 items-center" }
const _hoisted_2 = { class: "flex text-2xl font-extrabold" }
const _hoisted_3 = { class: "flex flex-row gap-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "px-2 pt-2 text-lg font-bold flex-1 truncate text-left" }, " Datos de Comunidad")
], -1)
const _hoisted_5 = { class: "w-full divide-gray-200 p-4" }
const _hoisted_6 = { class: "flex flex-col pb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Nombre de la comunidad ", -1)
const _hoisted_8 = { class: "text-lg font-semibold" }
const _hoisted_9 = { class: "flex flex-col py-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Dirección", -1)
const _hoisted_11 = { class: "text-lg font-semibold" }
const _hoisted_12 = { class: "flex flex-col pt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Rut", -1)
const _hoisted_14 = { class: "text-lg font-semibold" }
const _hoisted_15 = { class: "flex flex-col h-full md:flex-row gap-8 p-8" }
const _hoisted_16 = { class: "flex flex-col h-full gap-4 justify-center items-center w-3/6" }
const _hoisted_17 = {
  key: 0,
  class: "flex rounded-xl"
}
const _hoisted_18 = { class: "flex rounded-xl" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "flex flex-col w-3/6 justify-center p-5"
}
const _hoisted_22 = {
  key: 1,
  class: "flex flex-col w-3/6 items-center justify-center p-5"
}
const _hoisted_23 = { class: "text-xl font-semibold my-4" }
const _hoisted_24 = { class: "w-full divide-gray-200 p-4 my-7" }
const _hoisted_25 = { class: "flex pb-3 justify-between" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Dirección", -1)
const _hoisted_27 = { class: "text-lg font-semibold" }
const _hoisted_28 = { class: "flex py-3 justify-between" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Cantidad de unidades ( oficinas, espacios, etc)", -1)
const _hoisted_30 = { class: "text-lg font-semibold" }
const _hoisted_31 = { class: "flex py-3 justify-between" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Constructora", -1)
const _hoisted_33 = { class: "text-lg font-semibold" }
const _hoisted_34 = { class: "flex py-3 justify-between" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Inmobiliaria", -1)
const _hoisted_36 = { class: "text-lg font-semibold" }
const _hoisted_37 = { class: "flex py-3 justify-between" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Año de construcción", -1)
const _hoisted_39 = { class: "text-lg font-semibold" }
const _hoisted_40 = { class: "flex py-3 justify-between" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Recepción Municipal", -1)
const _hoisted_42 = { class: "text-lg font-semibold" }
const _hoisted_43 = { class: "flex py-3 justify-between" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Recepción Municipal", -1)
const _hoisted_45 = { class: "text-lg font-semibold" }
const _hoisted_46 = { class: "flex py-3 justify-between" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Cantidad de pisos", -1)
const _hoisted_48 = { class: "text-lg font-semibold" }
const _hoisted_49 = { class: "flex py-3 justify-between" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Cantidad de subterráneos ", -1)
const _hoisted_51 = { class: "text-lg font-semibold" }
const _hoisted_52 = { class: "flex py-3 justify-between" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Cantidad de unidades", -1)
const _hoisted_54 = { class: "text-lg font-semibold" }
const _hoisted_55 = { class: "flex py-3 justify-between" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Cantidad de Locales Comerciales", -1)
const _hoisted_57 = { class: "text-lg font-semibold" }
const _hoisted_58 = { class: "flex py-3 justify-between" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("dt", { class: "mb-1 md:text-lg" }, "Cantidad de bodegas", -1)
const _hoisted_60 = { class: "text-lg font-semibold" }
const _hoisted_61 = { class: "flex flex-row h-full w-full my-4 gap-4" }
const _hoisted_62 = { class: "flex flex-col h-full w-full" }
const _hoisted_63 = { class: "flex flex-col h-full w-full" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "px-2 pt-2 text-lg font-bold flex-1 truncate text-left" }, " Emergencias de personal")
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "px-2 pt-2 text-lg font-bold flex-1 truncate text-left" }, " Emergencias de residente")
], -1)
const _hoisted_66 = { class: "flex w-full gap-4" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h3", { class: "flex justify-center text-lg font-bold" }, "Control de acceso", -1)
const _hoisted_68 = { class: "flex px-4 py-2 text-gray-700" }
const _hoisted_69 = { class: "flex justify-end" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "flex justify-between" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = { class: "flex justify-between" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = { key: 0 }
const _hoisted_77 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_79 = [
  _hoisted_78
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_ComponentCard = _resolveComponent("ComponentCard")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_BlockFormQuestion = _resolveComponent("BlockFormQuestion")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_AddButton = _resolveComponent("AddButton")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_2, " Block: " + _toDisplayString(_ctx.blockUpdate.name), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "flex border-2 border-success text-success rounded-lg p-2 hover:bg-green-50",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:visible', false)))
        }, [
          _createElementVNode("strong", _hoisted_3, [
            _createVNode(_component_mdicon, { name: "backup-restore" }),
            _createTextVNode(" Volver a Blocks ")
          ])
        ])
      ])
    ]),
    _createVNode(_component_ComponentCard, { class: "my-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_ComponentCard, {
          bg_color: "bg-success",
          color: "text-white",
          class: "w-full"
        }, {
          header: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createElementVNode("dl", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("dd", _hoisted_8, _toDisplayString(_ctx.community?.name), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("dd", _hoisted_11, _toDisplayString(_ctx.community?.address), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("dd", _hoisted_14, _toDisplayString(_ctx.community?.rut), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("section", _hoisted_15, [
          _createElementVNode("section", _hoisted_16, [
            (_ctx.blockUpdate.dynamicLink)
              ? (_openBlock(), _createElementBlock("figure", _hoisted_17, [
                  _createVNode(_component_vue_qrcode, {
                    value: _ctx.blockUpdate.dynamicLink,
                    width: "400"
                  }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("figure", _hoisted_18, [
              (_ctx.blockUpdate.thumbnail != null)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: `${_ctx.getEnvConfig().apiURL}/${_ctx.blockUpdate.thumbnail}`,
                    class: "h-full object-cover transition ease-in-out delay-50 hover:scale-110 rounded-xl",
                    style: {"width":"20vw"}
                  }, null, 8, _hoisted_19))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: `${_ctx.getEnvConfig().apiURL}/media/community/community/community.png`,
                    class: "h-full object-cover transition ease-in-out delay-50 hover:scale-110 rounded-xl",
                    style: {"width":"20vw"}
                  }, null, 8, _hoisted_20))
            ])
          ]),
          (_ctx.isDataEditable)
            ? (_openBlock(), _createElementBlock("aside", _hoisted_21, [
                _createVNode(_component_TextField, {
                  label: "Nombre del edificio",
                  model: _ctx.blockUpdate.name,
                  "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.blockUpdate.name) = $event)),
                  type: "text",
                  name: "nombre"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Nombre compañía",
                  model: _ctx.blockUpdate.companyName,
                  "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.blockUpdate.companyName) = $event)),
                  type: "text",
                  name: "nombre compañia"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Rut de la compañía",
                  model: _ctx.blockUpdate.rut,
                  "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.blockUpdate.rut) = $event)),
                  type: "text",
                  name: "rut"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Dirección de la compañía",
                  model: _ctx.blockUpdate.address,
                  "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.blockUpdate.address) = $event)),
                  type: "text",
                  name: "direccion"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Año de construcción",
                  model: _ctx.blockUpdate.constructionYear,
                  "onUpdate:model": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.blockUpdate.constructionYear) = $event)),
                  type: "text",
                  name: "año contruccion"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Compañía de construcción",
                  model: _ctx.blockUpdate.constructionCompany,
                  "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.blockUpdate.constructionCompany) = $event)),
                  type: "text",
                  name: "Compañia de contruccion"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "estado de la compañía",
                  model: _ctx.blockUpdate.realStateAgency,
                  "onUpdate:model": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.blockUpdate.realStateAgency) = $event)),
                  type: "text",
                  name: "Año de construcción"
                }, null, 8, ["model"]),
                (_ctx.blockUpdate.municipalAcceptanceDate)
                  ? (_openBlock(), _createBlock(_component_TextField, {
                      key: 0,
                      label: "Fecha de recepcion municipal",
                      model: _ctx.date,
                      "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.date) = $event)),
                      type: "date",
                      name: "Fecha de recepcion municipal"
                    }, null, 8, ["model"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_TextField, {
                  label: "Tipo de gas",
                  model: _ctx.blockUpdate.gasType,
                  "onUpdate:model": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.blockUpdate.gasType) = $event)),
                  type: "text",
                  name: "Tipo de gas"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Total de edificios comerciales",
                  model: _ctx.blockUpdate.totalCommercialPremises,
                  "onUpdate:model": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.blockUpdate.totalCommercialPremises) = $event)),
                  type: "number",
                  name: "Total de edificios comerciales"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Total de pisos",
                  model: _ctx.blockUpdate.totalFloors,
                  "onUpdate:model": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.blockUpdate.totalFloors) = $event)),
                  type: "number",
                  name: "Total de pisos"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Total de estacionamiento",
                  model: _ctx.blockUpdate.totalParkingSpots,
                  "onUpdate:model": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.blockUpdate.totalParkingSpots) = $event)),
                  type: "number",
                  name: "Total de estacionamiento"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Total de piso",
                  model: _ctx.blockUpdate.totalUndegroundLevels,
                  "onUpdate:model": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.blockUpdate.totalUndegroundLevels) = $event)),
                  type: "number",
                  name: "Total de piso"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Total de unidades",
                  model: _ctx.blockUpdate.totalUnits,
                  "onUpdate:model": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.blockUpdate.totalUnits) = $event)),
                  type: "number",
                  name: "Total de unidades"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Total de estacionamiento de visitantes",
                  model: _ctx.blockUpdate.totalVisitorParkingSpots,
                  "onUpdate:model": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.blockUpdate.totalVisitorParkingSpots) = $event)),
                  type: "number",
                  name: "Total de estacionamiento de visitantes"
                }, null, 8, ["model"]),
                _createVNode(_component_TextField, {
                  label: "Total de bodegas",
                  model: _ctx.blockUpdate.totalWarehouseSpaces,
                  "onUpdate:model": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.blockUpdate.totalWarehouseSpaces) = $event)),
                  type: "number",
                  name: "Total de bodegas"
                }, null, 8, ["model"]),
                (_ctx.isModified)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.updateHandleBlock && _ctx.updateHandleBlock(...args))),
                      class: "px-4 py-2 bg-green-700 text-white hover:bg-green-600 focus:bg-green-600 rounded"
                    }, " Actualizar "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isDataEditable)
            ? (_openBlock(), _createElementBlock("aside", _hoisted_22, [
                _createElementVNode("p", _hoisted_23, " Información de block " + _toDisplayString(_ctx.blockUpdate.name), 1),
                _createElementVNode("dl", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("dd", _hoisted_27, _toDisplayString(_ctx.blockUpdate.address), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("dd", _hoisted_30, _toDisplayString(_ctx.blockUpdate.totalUnits), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("dd", _hoisted_33, _toDisplayString(_ctx.blockUpdate.constructionCompany), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("dd", _hoisted_36, _toDisplayString(_ctx.blockUpdate.realStateAgency), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("dd", _hoisted_39, _toDisplayString(_ctx.blockUpdate.constructionYear), 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("dd", _hoisted_42, _toDisplayString(_ctx.blockUpdate.totalFloors), 1)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("dd", _hoisted_45, _toDisplayString(_ctx.blockUpdate.municipalAcceptanceDate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("dd", _hoisted_48, _toDisplayString(_ctx.blockUpdate.totalFloors), 1)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("dd", _hoisted_51, _toDisplayString(_ctx.blockUpdate.totalUndegroundLevels), 1)
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("dd", _hoisted_54, _toDisplayString(_ctx.blockUpdate.totalUnits), 1)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("dd", _hoisted_57, _toDisplayString(_ctx.blockUpdate.totalCommercialPremises), 1)
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createElementVNode("dd", _hoisted_60, _toDisplayString(_ctx.blockUpdate.totalWarehouseSpaces), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[18] || (_cache[18] = () => _ctx.isDataEditable = !_ctx.isDataEditable),
            class: "block p-2 bg-green-700 text-white rounded-full w-[40px] h-[40px] hover:bg-green-500"
          }, [
            _createVNode(_component_mdicon, { name: "circle-edit-outline" })
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_61, [
      _createElementVNode("article", _hoisted_62, [
        _createVNode(_component_BlockFormQuestion, {
          blockId: _ctx.blockId,
          communityId: _ctx.communityId
        }, null, 8, ["blockId", "communityId"])
      ]),
      _createElementVNode("article", _hoisted_63, [
        _createVNode(_component_ComponentCard, { class: "full p-4" }, {
          header: _withCtx(() => [
            _hoisted_64
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Accordion, {
              items: _ctx.formattedInstructionsPersonal,
              "header-color": 'bg-success'
            }, null, 8, ["items"])
          ]),
          _: 1
        }),
        _createVNode(_component_ComponentCard, { class: "full p-4" }, {
          header: _withCtx(() => [
            _hoisted_65
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Accordion, {
              items: _ctx.formattedInstructionsResident,
              "header-color": 'bg-success',
              centerContent: false,
              multiple: false
            }, null, 8, ["items"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_66, [
      _createVNode(_component_ComponentCard, { class: "w-full p-4 mt-4 mb-4" }, {
        header: _withCtx(() => [
          _createVNode(_component_AddButton, { onClick: _ctx.addItem }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("section", null, [
            _hoisted_67,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedControlAccess, (item, index) => {
              return (_openBlock(), _createElementBlock("article", {
                key: index,
                class: "m-2"
              }, [
                _createVNode(_component_Accordion, {
                  items: [item],
                  headerColor: 'bg-success'
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("p", null, _toDisplayString(item.content), 1)
                    ])
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("footer", _hoisted_69, [
                      _createElementVNode("button", {
                        class: "flex px-4 py-2 mb-2 text-sm font-medium text-white bg-warning rounded-md hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-warning",
                        onClick: ($event: any) => (_ctx.editItem(index))
                      }, " Editar ", 8, _hoisted_70),
                      _createElementVNode("button", {
                        class: "flex px-4 py-2 ml-2 mr-2 mb-2 text-sm font-medium text-white bg-danger rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-danger",
                        onClick: ($event: any) => (_ctx.deleteItem(index))
                      }, " Eliminar ", 8, _hoisted_71)
                    ]),
                    _createVNode(_component_ModalAlert, {
                      title: 'Eliminar consulta',
                      message: '¿Esta seguro de eliminar esta consulta?',
                      visible: _ctx.showAlertModal,
                      onAccept: _ctx.handleAccept,
                      onCancelAlert: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showAlertModal = false))
                    }, null, 8, ["visible", "onAccept"])
                  ]),
                  _: 2
                }, 1032, ["items"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Modal, {
      title: "Agregar control de acceso",
      visible: _ctx.showModalAdd,
      "onUpdate:visible": _cache[24] || (_cache[24] = (e) => _ctx.showModalAdd = e)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TextField, {
          label: "Nombre",
          model: _ctx.nameField,
          "onUpdate:model": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.nameField) = $event)),
          type: "text",
          name: "name"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Descripción",
          model: _ctx.descriptionField,
          "onUpdate:model": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.descriptionField) = $event)),
          type: "textarea",
          name: "description"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 bg-danger hover:bg-red-700 text-white focus:bg-red-700 rounded-md",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showModalAdd = false))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 bg-success text-white hover:bg-green-700 focus:bg-green-700 rounded-md", { 'opacity-50 cursor-not-allowed disabled:pointer-events-none': !_ctx.isFieldsFilled }]),
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.saveAddItem && _ctx.saveAddItem(...args))),
            disabled: !_ctx.isFieldsFilled
          }, "Agregar", 10, _hoisted_73)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Modal, {
      title: "Editar control de acceso",
      visible: _ctx.showModalEdit,
      "onUpdate:visible": _cache[29] || (_cache[29] = (e) => _ctx.showModalEdit = e)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TextField, {
          label: "Nombre",
          model: _ctx.nameField,
          "onUpdate:model": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.nameField) = $event)),
          type: "text",
          name: "name"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Descripción",
          model: _ctx.descriptionField,
          "onUpdate:model": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.descriptionField) = $event)),
          type: "textarea",
          name: "name"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 bg-gray-300 hover:bg-gray-400 text-white focus:bg-gray-400 rounded-md",
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showModalEdit = false))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 bg-green-500 text-white hover:bg-green-700 focus:bg-green-700 rounded-md", { 'opacity-50 cursor-not-allowed disabled:pointer-events-none': !_ctx.isFieldsFilled }]),
            onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.saveEditItem && _ctx.saveEditItem(...args))),
            disabled: !_ctx.isFieldsFilled
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_76, "Editar"))
              : (_openBlock(), _createElementBlock("span", _hoisted_77, _hoisted_79))
          ], 10, _hoisted_75)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.success)
      ? (_openBlock(), _createBlock(_component_ModalAlert, {
          key: 0,
          visible: _ctx.success,
          option: true,
          onAccept: _ctx.handleAcceptSuccess
        }, null, 8, ["visible", "onAccept"]))
      : _createCommentVNode("", true)
  ]))
}